import { render, staticRenderFns } from "./AddNewMeeting.vue?vue&type=template&id=152af1b0&scoped=true&"
import script from "./AddNewMeeting.vue?vue&type=script&lang=js&"
export * from "./AddNewMeeting.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./AddNewMeeting.vue?vue&type=style&index=1&id=152af1b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152af1b0",
  null
  
)

export default component.exports